import CaseIdAnchor from './CaseIdAnchor';

export default CaseIdAnchor;